module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/bg_denshokan-482ea19360a29a082d2da615d0c654a9.jpg";